import {Component, OnDestroy, OnInit} from "@angular/core";
import {FormGroup, Validators, FormBuilder} from "@angular/forms";
import {ModalController, Events} from "ionic-angular";
import {TranslateService} from "@ngx-translate/core"
import {User} from "../../shared/user/user.model";
import {validateCPR} from "../../../app/core/validators";
import {Language} from "../../shared/language/language.model";
import {JobType} from "../../shared/job-type/job-type.model";
import {ToastService} from "../../../app/core/toast.service";
import {LanguageService} from "../../shared/language/language.service";
import {ProfileService} from "../profile.service";
import {JobTypeService} from "../../shared/job-type/job-type.service";
import {CountryCodesService} from "../../shared/country-codes.service";
import {PlacesSearchModal} from "../../../app/components/places-search-modal/places-search-modal.component";
import {Speciality} from "../../shared/specialities/speciality.model";
import {SpecialitiesSelectModal} from "../../../app/components/specialities-select-modal/specialities-select-modal.component";

@Component({
  selector: 'app-interpreter-profile',
  templateUrl: 'interpreter-profile.component.html',
})
export class InterpreterProfileComponent implements OnInit, OnDestroy {
  form: FormGroup;
  user: User = new User();
  private userControlsConfig = {
    email: ['', [Validators.required, Validators.email]],
    password: [''],
    name: ['', Validators.required],
    identity_number: ['', [Validators.required, validateCPR]],
    phone: ['', Validators.required],
    phone_country_code: ['', Validators.required],
    address: ['', Validators.required],
    gender: [null, Validators.required],
    languages: [null, Validators.required],
    file_entries: [[]],
    picture: [null],
    job_types: [null, Validators.required],
    /*iban: [''],*/
    bank_reg_no: ['', [Validators.minLength(4), Validators.maxLength(4)]],
    bank_account_no: ['', [Validators.minLength(7), Validators.maxLength(10)]],
    about: [''],
    education: [''],
    experience: ['']
  };
  languages: Language[];
  job_types: JobType[];
  specialities: Speciality[];
  submitted: boolean = false;

  constructor(fb: FormBuilder,
              private modalCtrl: ModalController,
              private toast: ToastService,
              private languageService: LanguageService,
              private events: Events,
              private profileService: ProfileService,
              private translate: TranslateService,
              private jobTypeService: JobTypeService,
              public countryCodesService: CountryCodesService) {

    this.form = fb.group(this.userControlsConfig);
  }

  ngOnInit(): any {
    this.languageService.getLanguages()
      .subscribe(languages => this.languages = languages);

    this.jobTypeService.getJobTypes()
      .subscribe(types => this.job_types = types);

    this.profileService.getProfile()
      .subscribe(profile => {
        this.user = profile;
        this.makeSureDefaultLangSelected();
      });

    this.events.subscribe('place:selected', (place) => this.updateAddress(place));
    this.events.subscribe('speciality:selected', (interpreter) => this.onSpecialitySelected(interpreter));
    this.events.subscribe('profile_edit_form:submitted', () => this.save())
  }

  ngOnDestroy() {
    this.events.unsubscribe('place:selected');
    this.events.unsubscribe('profile_edit_form:submitted');
    this.events.unsubscribe('speciality:selected');
  }

  private makeSureDefaultLangSelected() {
    if (this.user.languages.indexOf(1) === -1) {
      this.user.languages.push(1);
    }
  }

  updatePicture(pic) {
    if (pic) {
      this.user.picture_id = pic.id;
    } else {
      this.user.picture_id = null;
    }
  }

  openPlacesSearchModal() {
    let modal = this.modalCtrl.create(PlacesSearchModal);
    modal.present();
  }

  updateAddress(place) {
    if (place.hasOwnProperty('formatted_address')) {
      this.user.address = place.formatted_address;
      this.user.address_latitude = place.geometry.location.lat();
      this.user.address_longitude = place.geometry.location.lng();
    }
  }

  onSpecialitySelected(speciality: any) {
    // Don't add duplicates
    let filtered = this.user.specialities.filter(user => user.id === speciality.id);
    if(filtered.length){
      return;
    }

    this.user.specialities.push(speciality);
  }

  save() {
    this.submitted = true;
    if (!this.form.valid) {
      return this.toast.show(this.translate.instant('global.form_invalid'));
    }

    this.profileService.updateProfile(this.user, 'interpreter')
      .subscribe((res) => this.toast.show(res.message));
  }

  isPreselected(lang) {
    // Danish should be always preselected
    return lang.id === 1;
  }

  removeSpeciality(index){
    this.user.specialities.splice(index, 1);
  }

  openSpecialitiesSelectModal(){
    let modal = this.modalCtrl.create(SpecialitiesSelectModal);
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/interpreter-profile/interpreter-profile.component.ts